import Select from 'react-select';
import styled from 'styled-components';

const StyledReactSelect = styled(Select)`
    margin-bottom: ${props => props.nomargin ? '0' : '0.5rem'};
    display: block;    
    font-size: 1rem;
    margin-right: ${props => props.spacingR ? '1rem' : '0'};
    > div {
        border-radius: 8px;
        background-color: #f8f9fa;
        border: 1px solid #ced4da;
        ${props => props.zIndexFix ? 'z-index: 2;' : null}
    }
    input&:focus {
        outline: none !important;
        border: none !important;
        border-bottom: 0 !important;
        box-shadow: none !important;
        background-color: transparent;
    }
`



const Label = styled.label`
    margin-bottom: 0.2rem;
`;

const customStyles = {
    control: (base, state) => ({
        ...base,
        border: "1px solid #ced4da"
    }),
    placeholder: () => ({
        fontSize: '1rem',
        color: '#5e6270',
        position: 'absolute',
        top: '50%',
        transform: 'translateY(-50%)',
        boxSizing: 'border-box'
    }),
    valueContainer: () => ({
        padding: '6px 10px',
        display: 'flex'
    }),
    input: () => ({
        margin: '0',
        "&:focus": {
            outline: 'none !important',
            border: 'none !important',
            borderBottom: '0 !important',
            boxShadow: 'none !important',
            backgroundColor: 'transparent'
        }
    })
};

const ReactSelect = ({ options, name, onChange, value, isDisabled, isAutoFocus, label, invalidfield, nomargin, zIndexFix, spacingR, customFilter }) => {
    let select = null;
    if (options) {
        select =
        <>
            {label ? <Label>{label}</Label> : null}
            <StyledReactSelect
                autoFocus={isAutoFocus}
                className={"basic-single"}
                classNamePrefix="select"
                name={name}
                value={options.filter(option => option.value === value)}
                styles={customStyles}
                options={options}
                zIndexFix={zIndexFix}
                isDisabled={isDisabled}   
                nomargin={nomargin}
                spacingR={spacingR}
                filterOption={customFilter}
                onChange={val => {
                    onChange(val.value);
                }}
                theme={theme => ({
                    ...theme,
                    borderRadius: 0,
                    colors: {
                        ...theme.colors,
                        primary25: '#ced4da',
                        primary50: '#ced4da',
                        primary: '#ee7330'
                    }
                })}
            />
        </>
    }
    return select;
};

export default ReactSelect;